import { HttpResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Constants } from "src/app/app.constants";
import { AppService } from "src/app/app.service";
import { StorageService } from "src/app/app.storage.service";

declare var $: any;
@Component({
    selector: 'app-get-started',
    templateUrl: './get-started.component.html',
    styleUrls: ['./get-started.component.css']
  })
  export class GeStartedComponent implements OnInit {
  
    constructor(private appService: AppService,
                private router: Router,
                private storageService: StorageService) { 
                  window['getStartedCompRef'] = { comp: this}
                }
  
  
    userName: string = null;
    profilePic: string = null;
    imageViewUrl: string = Constants.IMAGE_BASE_URL;
    isCallBackLinkDisable: boolean = false;
    sectionHeaderList: any[] = ["Get Started", "Web App Features", "Mobile App Features", "APIs", "Contact Us"];
    selectedSectionHeader: string = "Get Started";

    ngOnInit(): void {
      let newUserInfo = this.storageService.getDataFromLocalStorage("newUserInfo");
      if(newUserInfo){
        this.userName = newUserInfo.name;
        this.profilePic = newUserInfo.profile;
      }

      this.enableFullPageJS();

      if ($(window).width() <= 768) {
        if ($.fn.fullpage) {
          $.fn.fullpage.setMouseWheelScrolling(false);
          $.fn.fullpage.setAllowScrolling(false);
        }

      }

      this.updateScrollBar();

    }

    updateScrollBar(){
      setTimeout(()=>{
        $(".content").mCustomScrollbar('update');
      }, 300)
    }

    enableFullPageJS(){
      let scope = window['getStartedCompRef'].comp;

      $('#fullpage').fullpage({

        anchors: [
          '/get-started#firstPage1', 
          '/get-started#firstPage2', 
          '/get-started#firstPage3', 
          '/get-started#secondPage', 
          '/get-started#3rdPage'
        ],
        menu: '#menu',
        css3: true,
        scrollOverflow: true,
        navigation: true,
        offsetSections: true,
        offsetSectionsKey: 'Y29kZXBlbi5pb196MDZiMlptYzJWMFUyVmpkR2x2Ym5NPWhPNA==',
        onLeave: function(index, nextIndex, direction){
          // console.log(index, nextIndex, direction)
          scope.selectedSectionHeader = scope.sectionHeaderList[nextIndex-1];
        },
      //   afterRender: function(){
      //     $.fn.fullpage.removeTouchHandler();
      // }
    });

   
    }

    ngOnDestroy(){
      $.fn.fullpage.destroy('all');
    }

    moveTo(index){
      $.fn.fullpage.moveTo(index);
      this.updateScrollBar();
    }

    ngAfterContentInit(){
      $(".content").mCustomScrollbar();
    }

    createAccount(){
      this.router.navigate(['account']);
        // let accessToken = this.storageService.getDataFromLocalStorage("getStartedAccessToken");
        // if(accessToken){
        //     this.appService.userInfo(accessToken)
        //     .subscribe((res: HttpResponse<any>) => {
        //       console.log(res);
        //       if (res.body.status == 200) {
        //         if (res.body.landing == Constants.LANDING_PAGE.FIELD_USER) {
        //           this.router.navigate(['field-user']);
        //           return;
        //         }
        //         let userData = res.body.user;
        //         if (userData) {
        //           // this.authService.setAccessToken(userData.accessToken);
    
        //           // this.storageService.setDataInLocalStorage("accessToken", userData.accessToken);
        //           this.storageService.setDataInLocalStorage("userData", userData);
        //           if (res.body.logo) {
        //             this.storageService.setDataInLocalStorage("logo", res.body.logo);
        //           }
        //           if (res.body.landing == Constants.LANDING_PAGE.WELCOME) {
        //             this.router.navigate(['account']);
        //           } else {
        //             this.router.navigate(['home']);
        //           }
    
        //         }
        //       } else if (res.body.status == 400) {
        //         this.appService.showInfoPopup("Oops...", res.body.error_description);
        //       }
    
        //     }, (error) => {
        //       console.log(error);
        //     });
        // }else{
        //     this.navigateToPage();
        // }
    }

    navigateToPage() {
      this.storageService.clearStorage();
      window.location.href = Constants.LOGIN_URL;
    }

    userManual(){
      window.open("https://www.mapmyindia.com/workmate/");
      // window.location.href="https://help.mapmyindia.com/category/workmate/";
    }

    contactUs(){
      $("#contactUs").trigger("click");
    }

    navToDiscoverApis(){
      window.open("https://mapmyindia.github.io/mapmyindia-workmate-apis/#/");
    }

    requestCallBack(){
      let accessToken = this.storageService.getDataFromLocalStorage("getStartedAccessToken");
      this.appService.requestCallBack(accessToken)
        .subscribe((res:HttpResponse<any>)=>{
          if(res.body.status == 200){
            this.appService.showInfoPopup("Success", res.body.message);
            this.isCallBackLinkDisable = true;
          }else{
            this.appService.showErrorPopup("Error", "Something went wrong!");
          }
         
        },(err)=>{
          this.appService.showErrorPopup("Error", "Something went wrong!");
        })
    }
    
  
  }
  